import React, { useState } from "react";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import NoteIcon from "@material-ui/icons/NoteAdd";
import DeleteIcon from "@material-ui/icons/Delete";
import Grid from "@material-ui/core/Grid";

import {
    StyledTableCell,
    StyledTableRow,
    useStyles,
} from "./timeInputRowStyles";

  
const TimeInputRow = props => {
    const classes = useStyles();

    return (
        <StyledTableRow>
            <StyledTableCell width="10%">
                <div>
                    <b>{props.task.toUpperCase()}</b>
                </div>
                <div style={{ fontSize: "12px" }}>
                    <b>
                        {props.status === "billable"
                            ? "Billable"
                            : "Non-Billable"}
                    </b>
                </div>
                <div>{props.project && props.project.name}</div>
            </StyledTableCell>
            <StyledTableCell align="right" width="10%">
                <form
                    className={classes.container}
                    style={{ display: "flex" }}
                    noValidate
                    autoComplete="off"
                >
                    <TextField
                        value={
                            props.task === "regular"
                                ? props.projectValues.sunday
                                : props.task === "holiday"
                                ? props.holidayValuesSunday
                                : props.task === "vacation"
                                ? props.vacationValuesSunday
                                : props.task === "sick"
                                ? props.sickValuesSunday
                                : props.task === "bereavement"
                                ? props.bereavementValuesSunday
                                : ""
                        }
                        onChange={e =>{
                            const value = e.target.value;
                            if(40>=value && 0<=value){
                                props.handleChange(e, props.task, props.project)
                            }
                        }}
                        name="sunday"
                        type="number"
                        className={classes.textField}
                        disabled={props.disable}
                    />
                    {((props.task === "regular" &&
                        props.projectValues.sunday) ||
                        (props.task === "holiday" &&
                            props.holidayValuesSunday) ||
                        (props.task === "vacation" &&
                            props.vacationValuesSunday) ||
                        (props.task === "sick" && props.sickValuesSunday)||
                        (props.task === "bereavement" && props.bereavementValuesSunday)) && (
                        <div
                            onClick={() =>
                                props.handleOpenNote(
                                    props.task,
                                    "sunday",
                                    props.project
                                )
                            }
                        >
                            <NoteIcon
                                className={classes.noteIcon}
                                color={
                                    props.task === "regular" &&
                                    props.projectNotes.sunday
                                        ? "primary"
                                        : props.task === "holiday" &&
                                          props.holidayNotesSunday
                                        ? "primary"
                                        : props.task === "vacation" &&
                                          props.vacationNotesSunday
                                        ? "primary"
                                        : props.task === "sick" &&
                                          props.sickNotesSunday
                                        ? "primary"
                                        : props.task === "bereavement" &&
                                          props.bereavementNotesSunday
                                        ? "primary"
                                        : "secondary"
                                }
                            />
                        </div>
                    )}
                </form>
            </StyledTableCell>
            <StyledTableCell width="10%">
                <form
                    className={classes.container}
                    noValidate
                    autoComplete="off"
                >
                    <TextField
                        value={
                            props.task === "regular"
                                ? props.projectValues.monday
                                : props.task === "holiday"
                                ? props.holidayValuesMonday
                                : props.task === "vacation"
                                ? props.vacationValuesMonday
                                : props.task === "sick"
                                ? props.sickValuesMonday
                                : props.task === "bereavement"
                                ? props.bereavementValuesMonday
                                : ""
                        }
                        onChange={e =>{
                            const value = e.target.value;
                            if(40>=value && 0<=value){
                                props.handleChange(e, props.task, props.project)
                            }
                        }}
                        name="monday"
                        type="number"
                        className={classes.textField}
                        disabled={props.disable}
                    />
                    {((props.task === "regular" &&
                        props.projectValues.monday) ||
                        (props.task === "holiday" &&
                            props.holidayValuesMonday) ||
                        (props.task === "vacation" &&
                            props.vacationValuesMonday) ||
                        (props.task === "sick" && props.sickValuesMonday)||
                        (props.task === "bereavement" && props.bereavementValuesMonday)) && (
                        <div
                            onClick={() =>
                                props.handleOpenNote(
                                    props.task,
                                    "monday",
                                    props.project
                                )
                            }
                        >
                            <NoteIcon
                                id="mon"
                                className={classes.noteIcon}
                                color={
                                    props.task === "regular" &&
                                    props.projectNotes.monday
                                        ? "primary"
                                        : props.task === "holiday" &&
                                          props.holidayNotesMonday
                                        ? "primary"
                                        : props.task === "vacation" &&
                                          props.vacationNotesMonday
                                        ? "primary"
                                        : props.task === "sick" &&
                                          props.sickNotesMonday
                                        ? "primary"
                                        : props.task === "bereavement" &&
                                          props.bereavementNotesMonday
                                        ? "primary"
                                        : "secondary"
                                }
                            />
                        </div>
                    )}
                </form>
            </StyledTableCell>
            <StyledTableCell align="right" width="10%">
                <form
                    className={classes.container}
                    style={{ display: "flex" }}
                    noValidate
                    autoComplete="off"
                >
                    <TextField
                        value={
                            props.task === "regular"
                                ? props.projectValues.tuesday
                                : props.task === "holiday"
                                ? props.holidayValuesTuesday
                                : props.task === "vacation"
                                ? props.vacationValuesTuesday
                                : props.task === "sick"
                                ? props.sickValuesTuesday
                                : props.task === "bereavement"
                                ? props.bereavementValuesTuesday
                                : ""
                        }
                        onChange={e =>{
                            const value = e.target.value;
                            if(40>=value && 0<=value){
                                props.handleChange(e, props.task, props.project)
                            }
                        }}
                        name="tuesday"
                        type="number"
                        className={classes.textField}
                        disabled={props.disable}
                    />
                    {((props.task === "regular" &&
                        props.projectValues.tuesday) ||
                        (props.task === "holiday" &&
                            props.holidayValuesTuesday) ||
                        (props.task === "vacation" &&
                            props.vacationValuesTuesday) ||
                        (props.task === "sick" && props.sickValuesTuesday)||
                        (props.task === "bereavement" && props.bereavementValuesTuesday)) && (
                        <div
                            onClick={() =>
                                props.handleOpenNote(
                                    props.task,
                                    "tuesday",
                                    props.project
                                )
                            }
                        >
                            <NoteIcon
                                id="tue"
                                className={classes.noteIcon}
                                color={
                                    props.task === "regular" &&
                                    props.projectNotes.tuesday
                                        ? "primary"
                                        : props.task === "holiday" &&
                                          props.holidayNotesTuesday
                                        ? "primary"
                                        : props.task === "vacation" &&
                                          props.vacationNotesTuesday
                                        ? "primary"
                                        : props.task === "sick" &&
                                          props.sickNotesTuesday
                                        ? "primary"
                                        : props.task === "bereavement" &&
                                          props.bereavementNotesTuesday
                                        ? "primary"
                                        : "secondary"
                                }
                            />
                        </div>
                    )}
                </form>
            </StyledTableCell>
            <StyledTableCell align="right" width="10%">
                <form
                    className={classes.container}
                    style={{ display: "flex" }}
                    noValidate
                    autoComplete="off"
                >
                    <TextField
                        value={
                            props.task === "regular"
                                ? props.projectValues.wednesday
                                : props.task === "holiday"
                                ? props.holidayValuesWednesday
                                : props.task === "vacation"
                                ? props.vacationValuesWednesday
                                : props.task === "sick"
                                ? props.sickValuesWednesday
                                : props.task === "bereavement"
                                ? props.bereavementValuesWednesday
                                : ""
                        }
                        onChange={e =>{
                            const value = e.target.value;
                            if(40>=value && 0<=value){
                                props.handleChange(e, props.task, props.project)
                            }
                        }}
                        name="wednesday"
                        type="number"
                        className={classes.textField}
                        disabled={props.disable}
                    />
                    {((props.task === "regular" &&
                        props.projectValues.wednesday) ||
                        (props.task === "holiday" &&
                            props.holidayValuesWednesday) ||
                        (props.task === "vacation" &&
                            props.vacationValuesWednesday) ||
                        (props.task === "sick" &&
                            props.sickValuesWednesday)||
                            (props.task === "bereavement" &&
                            props.bereavementValuesWednesday)) && (
                        <div
                            onClick={() =>
                                props.handleOpenNote(
                                    props.task,
                                    "wednesday",
                                    props.project
                                )
                            }
                        >
                            <NoteIcon
                                className={classes.noteIcon}
                                color={
                                    props.task === "regular" &&
                                    props.projectNotes.wednesday
                                        ? "primary"
                                        : props.task === "holiday" &&
                                          props.holidayNotesWednesday
                                        ? "primary"
                                        : props.task === "vacation" &&
                                          props.vacationNotesWednesday
                                        ? "primary"
                                        : props.task === "sick" &&
                                          props.sickNotesWednesday
                                        ? "primary"
                                        : props.task === "bereavement" &&
                                          props.bereavementNotesWednesday
                                        ? "primary"
                                        : "secondary"
                                }
                            />
                        </div>
                    )}
                </form>
            </StyledTableCell>
            <StyledTableCell align="right" width="10%">
                <form
                    className={classes.container}
                    style={{ display: "flex" }}
                    noValidate
                    autoComplete="off"
                >
                    <TextField
                        value={
                            props.task === "regular"
                                ? props.projectValues.thursday
                                : props.task === "holiday"
                                ? props.holidayValuesThursday
                                : props.task === "vacation"
                                ? props.vacationValuesThursday
                                : props.task === "sick"
                                ? props.sickValuesThursday
                                : props.task === "bereavement"
                                ? props.bereavementValuesThursday
                                : ""
                        }
                        onChange={e =>{
                            const value = e.target.value;
                            if(40>=value && 0<=value){
                                props.handleChange(e, props.task, props.project)
                            }
                        }}
                        name="thursday"
                        type="number"
                        className={classes.textField}
                        disabled={props.disable}
                    />
                    {((props.task === "regular" &&
                        props.projectValues.thursday) ||
                        (props.task === "holiday" &&
                            props.holidayValuesThursday) ||
                        (props.task === "vacation" &&
                            props.vacationValuesThursday) ||
                        (props.task === "sick" &&
                            props.sickValuesThursday)||
                            (props.task === "bereavement" &&
                            props.bereavementValuesThursday)) && (
                        <div
                            onClick={() =>
                                props.handleOpenNote(
                                    props.task,
                                    "thursday",
                                    props.project
                                )
                            }
                        >
                            <NoteIcon
                                className={classes.noteIcon}
                                color={
                                    props.task === "regular" &&
                                    props.projectNotes.thursday
                                        ? "primary"
                                        : props.task === "holiday" &&
                                          props.holidayNotesThursday
                                        ? "primary"
                                        : props.task === "vacation" &&
                                          props.vacationNotesThursday
                                        ? "primary"
                                        : props.task === "sick" &&
                                          props.sickNotesThursday
                                        ? "primary"
                                        : props.task === "bereavement" &&
                                          props.bereavementNotesThursday
                                        ? "primary"
                                        : "secondary"
                                }
                            />
                        </div>
                    )}
                </form>
            </StyledTableCell>
            <StyledTableCell align="right" width="10%">
                <form
                    className={classes.container}
                    style={{ display: "flex" }}
                    noValidate
                    autoComplete="off"
                >
                    <TextField
                        value={
                            props.task === "regular"
                                ? props.projectValues.friday
                                : props.task === "holiday"
                                ? props.holidayValuesFriday
                                : props.task === "vacation"
                                ? props.vacationValuesFriday
                                : props.task === "sick"
                                ? props.sickValuesFriday
                                : props.task === "bereavement"
                                ? props.bereavementValuesFriday
                                : ""
                        }
                        onChange={e =>{
                            const value = e.target.value;
                            if(40>=value && 0<=value){
                                props.handleChange(e, props.task, props.project)
                            }
                        }}
                        name="friday"
                        type="number"
                        className={classes.textField}
                        disabled={props.disable}
                    />
                    {((props.task === "regular" &&
                        props.projectValues.friday) ||
                        (props.task === "holiday" &&
                            props.holidayValuesFriday) ||
                        (props.task === "vacation" &&
                            props.vacationValuesFriday) ||
                        (props.task === "sick" && props.sickValuesFriday)||
                        (props.task === "bereavement" && props.bereavementValuesFriday)) && (
                        <div
                            onClick={() =>
                                props.handleOpenNote(
                                    props.task,
                                    "friday",
                                    props.project
                                )
                            }
                        >
                            <NoteIcon
                                className={classes.noteIcon}
                                color={
                                    props.task === "regular" &&
                                    props.projectNotes.friday
                                        ? "primary"
                                        : props.task === "holiday" &&
                                          props.holidayNotesFriday
                                        ? "primary"
                                        : props.task === "vacation" &&
                                          props.vacationNotesFriday
                                        ? "primary"
                                        : props.task === "sick" &&
                                          props.sickNotesFriday
                                        ? "primary"
                                        : props.task === "bereavement" &&
                                          props.bereavementNotesFriday
                                        ? "primary"
                                        : "secondary"
                                }
                            />
                        </div>
                    )}
                </form>
            </StyledTableCell>
            <StyledTableCell align="right" width="10%">
                <form
                    className={classes.container}
                    style={{ display: "flex" }}
                    noValidate
                    autoComplete="off"
                >
                    <TextField
                        value={
                            props.task === "regular"
                                ? props.projectValues.saturday
                                : props.task === "holiday"
                                ? props.holidayValuesSaturday
                                : props.task === "vacation"
                                ? props.vacationValuesSaturday
                                : props.task === "sick"
                                ? props.sickValuesSaturday
                                : props.task === "bereavement"
                                ? props.bereavementValuesSaturday 
                                : ""
                        }
                        onChange={e =>{
                            const value = e.target.value;
                            if(40>=value && 0<=value){
                                props.handleChange(e, props.task, props.project)
                            }
                        }}
                        name="saturday"
                        type="number"
                        className={classes.textField}
                        disabled={props.disable}
                    />
                    {((props.task === "regular" &&
                        props.projectValues.saturday) ||
                        (props.task === "holiday" &&
                            props.holidayValuesSaturday) ||
                        (props.task === "vacation" &&
                            props.vacationValuesSaturday) ||
                        (props.task === "sick" &&
                            props.sickValuesSaturday) ||
                            (props.task === "bereavement" &&
                            props.bereavementValuesSaturday)) && (
                        <div
                            onClick={() =>
                                props.handleOpenNote(
                                    props.task,
                                    "saturday",
                                    props.project
                                )
                            }
                        >
                            <NoteIcon
                                className={classes.noteIcon}
                                color={
                                    props.task === "regular" &&
                                    props.projectNotes.saturday
                                        ? "primary"
                                        : props.task === "holiday" &&
                                          props.holidayNotesSaturday
                                        ? "primary"
                                        : props.task === "vacation" &&
                                          props.vacationNotesSaturday
                                        ? "primary"
                                        : props.task === "sick" &&
                                          props.sickNotesSaturday
                                        ? "primary"
                                        : props.task === "bereavement" &&
                                          props.bereavementNotesSaturday
                                        ? "primary"
                                        : "secondary"
                                }
                            />
                        </div>
                    )}
                </form>
            </StyledTableCell>

            <StyledTableCell
                component="th"
                scope="row"
                width="10%"
                className={classes.totalColumn}
            >
                <Grid container>
                    <div>{props.calcTotal(props.task, props.project)}</div>
                    {props.project !== props.defaultProject && (
                        <IconButton
                            aria-label="delete"
                            className={classes.margin}
                            disabled={props.disable}
                            size="small"
                            onClick={() =>
                                props.deleteProject(props.task, props.project)
                            }
                        >
                            <DeleteIcon fontSize="small" />
                        </IconButton>
                    )}
                </Grid>
            </StyledTableCell>
        </StyledTableRow>
    );
};

export default TimeInputRow;
